import {getHexDistance} from "../coords/getHexDistance";

/**
 * Следующий отряд для автовыбора (spec unit-auto-selection): ближайший к
 * originHexKey из тех, кто может действовать и не пропустил ход
 * (actionableIds подсчета дел уже без пропусков). Расстояние — в гексах; при
 * равенстве — по id отряда, чтобы порядок был одинаковым при каждом повторе.
 *
 * Начало отсчета: в начале этапа — ячейка в центре свободной области поля,
 * после действия — ячейка, где отряд оказался, после пропуска — ячейка
 * пропустившего.
 *
 * @param {Object} params
 * @param {string[]} params.actionableIds - отряды, которые могут действовать
 * @param {Object[]} params.units - все отряды на поле
 * @param {?string} params.originHexKey - откуда считать расстояние; без него —
 *   первый по id
 * @returns {?Object} отряд или null, если выбирать некого
 */
export const pickNextActionableUnit = ({actionableIds, units, originHexKey}) => {
  const actionable = new Set(actionableIds);
  const candidates = (units || []).filter((unit) => actionable.has(unit.id));
  if (!candidates.length) {
    return null;
  }

  const distanceOf = (unit) => (originHexKey ? getHexDistance(originHexKey, unit.hexKey) : 0);
  return candidates.reduce((best, unit) => {
    const bestDistance = distanceOf(best);
    const distance = distanceOf(unit);
    if (distance !== bestDistance) {
      return distance < bestDistance ? unit : best;
    }
    return unit.id < best.id ? unit : best;
  });
};
